<template>
  <div>
    <base-page-component>

      <b-card>
        <div slot="header">
          Inventory Download
        </div>
        <!-- User Interface controls -->
        <b-row>
          <b-col md="12" class="my-0">
            <b-form-group class="float-right">
              <b-input-group>
                <b-input-group-append>
                  <div style="text-align:right; vertical-align:central">
                    Total {{ totalCount }} | Displayed {{ GetRowCount() }} | <a href="#" @click="QuickSearch('Completed')">Completed</a> {{RecordsStatistics.completed}}  | <a href="#" @click="QuickSearch('Running')">Running</a> {{RecordsStatistics.running}} | <a href="#" @click="QuickSearch('Failed')">Failed</a> {{RecordsStatistics.failed}} | <a href="#" @click="QuickSearch('Terminated')">Terminated</a> {{RecordsStatistics.terminated}}
                  </div>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
          <b-row>
            <b-col md="6" class="my-0">
              <b-form-group class="my-1">
                <b-input-group>
                  <!--v-on:keyup.esc="ClearSearch"-->
                  <b-form-input @keydown.native="EscClearSearch" v-model="tbxFilter" id="tbxFilter"
                                placeholder="Type to search by account number or name"></b-form-input>
                  <b-input-group-append>
                    <b-btn class="btn btn-default text-white ml-2" @click="ClearSearch">
                      <i class="fa fa-eraser" title="ClearSearch"></i> <strong class="text-white">Clear Search</strong>
                    </b-btn>
                    <b-btn class="btn btn-success text-white ml-2" @click="RefreshData">
                      <i class="fa fa-refresh" title="Refresh"></i> <strong class="text-white">Refresh</strong>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="6" class="my-0">
              <b-form-group class="my-1 float-right">
                <b-input-group>
                  <b-input-group-append>
                    <b-btn class="btn btn-danger text-white ml-2 pull-right" @click="ProcessAll">
                      <i class="fa fa-play-circle" title="Process All"></i> <strong class="text-white">Process All</strong>
                    </b-btn>
                    <b-btn class="btn btn-danger text-white ml-2 pull-right" @click="TerminateRunning">
                      <i class="fa fa-play-circle" title="Terminate Running"></i> <strong class="text-white">Terminate Running</strong>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

          </b-row>
          <!-- Main table element -->
          <b-table id="tblStatuses" :items="FilteredRecords" hover striped bordered small :fields="fields"
                   :current-page="currentPage" :per-page="perPage" :sort-compare="onSortChanged" show-empty>
            <template slot="show_details" slot-scope="row">
              <b-row class="px-2">
                <b-col md="12">
                  <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                  <b-button v-if="CanGetLog(row.item)" @click.stop="row.toggleDetails"
                            class="btn btn-info text-white btn-sm">
                    <i class="fa fa-info-circle" title="Edit"></i> <strong class="text-white">
                      {{
 row.detailsShowing ?
                  'Hide' : 'Show'
                      }} Log Details
                    </strong>
                  </b-button>
                  <!-- In some circumstances you may need to use @click.native.stop instead -->
                  <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                  <!--<b-form-checkbox @click.native.stop @change="row.toggleDetails" v-model="row.detailsShowing">
                Details via check
                </b-form-checkbox>
            -->
                </b-col>
              </b-row>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row>
                  <b-col>
                    <b-button class="btn btn-info text-white btn-sm" @click="row.toggleDetails">
                      Hide Log Details
                    </b-button>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <b-card>
                      <div slot="header">
                        <strong>Log entries</strong>
                      </div>
                      <div style="height: 350px; overflow: auto">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th style="width: 15%">Timestamp</th>
                              <th style="width: 15%">How long ago</th>
                              <th style="width: 70%">Message</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="logEntry in row.item.log" v-bind:key="logEntry.Key">
                              <td aria-colindex="1" v-bind:class="GetLogEntryClass(logEntry)">
                                {{ logEntry.Timestamp | formatDate }}
                              </td>
                              <td aria-colindex="2" v-bind:class="GetLogEntryClass(logEntry)">
                                {{ logEntry.Timestamp | formatDateToNow }}
                              </td>
                              <td aria-colindex="3" v-bind:class="GetLogEntryClass(logEntry)">
                                {{ logEntry.Message }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card>
            </template>
            <template slot="accountName" slot-scope="row">
              {{row.value}}
            </template>
            <template slot="accountLastRun" slot-scope="data">
              {{data.item.accountLastRun | formatDate}}
            </template>
            <template slot="sinceLastRun" slot-scope="data">
              {{data.item.accountLastRun | formatDateToNow}}
            </template>
            <template slot="accountStatusDescription" slot-scope="data">
              <b-row class="px-2">
                <b-col md="12">
                  <div class="text-center">
                    <span class="badge badge-info text-white" v-bind:class="{'badge-danger': IsDanger(data.item) }">{{data.item.accountStatusDescription}}</span>
                  </div>
                </b-col>
              </b-row>
            </template>
            <template slot="overrideFileIfExists" slot-scope="data">
              <b-row class="px-2" v-if="CanRunImport(data.item)">
                <b-col md="12">
                  <!--value="accepted" unchecked-value="not_accepted"-->
                  <b-form-checkbox v-model="data.item.overrideFileIfExists">
                    <span>Override file if exists</span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </template>
            <template slot="buttons" slot-scope="data">
              <b-row class="px-2" v-if="CanRunImport(data.item)">
                <b-col md="12">
                  <b-btn class="btn btn-success text-white btn-sm"
                         @click="RunImport(data.item.account, data.item.accountName, data.item.overrideFileIfExists)">
                    <i class="fa fa-play-circle" title="Edit"></i> <strong class="text-white">Run Import</strong>
                  </b-btn>
                </b-col>
              </b-row>
              <b-row class="px-2" v-if="CanBeTerminated(data.item)">
                <b-col md="12">
                  <b-btn class="btn btn-danger text-white btn-sm" @click="RunTerminate(data.item.pid, data.item.account)">
                    <i class="fa fa-ban" title="Terminate"></i> <strong class="text-white">Terminate</strong>
                  </b-btn>
                </b-col>
              </b-row>
            </template>
          </b-table>
          <!-- NAV -->
          <nav>
            <b-pagination :total-rows="GetRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next"></b-pagination>
          </nav>
      </b-card>

    </base-page-component>
  </div>
</template>

<script>
import {basePageMixin} from '@/mixins/basePageMixin'
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'

export default {
  components: {
    loading
  },
  mixins: [basePageMixin],
  data () {
    var filter = localStorage.getItem('InventoryDownloadtbxFilter')
    if (filter === null || filter === 'null' || filter === 'undefined') {
      filter = undefined
    }
    return {
      tbxFilter: filter,
      intervalHandle: undefined,
      gettingData: false,
      gettingDataInterval: 5000,
      totalCount: 0,
      Items: [],
      itemsObject: {},
      fields: [
        {key: 'account', label: 'Account #', sortable: true},
        {key: 'accountName', label: 'Account Name', sortable: true},
        {key: 'accountLastRun', label: 'Last Run', sortable: true},
        {key: 'sinceLastRun', label: 'Last Run Was', sortable: false},
        {key: 'accountStatusDescription', label: 'Status', sortable: true},
        {key: 'overrideFileIfExists', label: 'Override file if exists', sortable: false},
        {key: 'buttons', label: '', sortable: false},
        {key: 'show_details', label: '', sortable: false}
      ],
      currentPage: 1,
      perPage: 15,
      onSortChanged (a, b, key) {
        if (['accountLastRun', 'EXPIRATION_DATE'].indexOf(key) !== -1) {
          var a1
          var b1
          switch (key) {
            case 'CREATED_TS':
            case 'accountLastRun':
              a1 = moment(a[key])
              b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            a1 = (a[key] + '')
            b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      },

      chat: undefined
    }
  },
  created () {
    let self = this

    var jqueryURL = window.location.protocol + '//' + window.location.host + '/Scripts/jquery.min.js'
    var signalrURL = window.location.protocol + '//' + window.location.host + '/Scripts/jquery.signalR.min.js'
    var hubsURL = window.location.protocol + '//' + window.location.host + '/signalr/hubs'

    self.$scriptLoader.load(jqueryURL, true).then(function (value1) {
      self.$scriptLoader.load(signalrURL, true).then(function (value2) {
        self.$scriptLoader.load(hubsURL, false).then(function (value3) {
          self.LoadData()
          self.ConnectSocket()
        }).catch(error => {
          self.toggleloader(false)
          let msg = 'Hubs loading: failed '
          self.showError(msg)
          console.log(`${msg} ${JSON.stringify(error)}`)
        })
      }).catch(error => {
        self.toggleloader(false)
        let msg = 'SignalR loading: failed '
        self.showError(msg)
        console.log(`${msg} ${JSON.stringify(error)}`)
      })
    }).catch(error => {
      self.toggleloader(false)
      let msg = 'jQuery loading: failed '
      self.showError(msg)
      console.log(`${msg} ${JSON.stringify(error)}`)
    })
  },
  methods: {
    QuickSearch (phrase) {
      let self = this
      self.tbxFilter = phrase.toLowerCase()
    },
    onSpecialMessage (key, value) {
      let self = this
      // console.log(`onSpecialMessage key: ${JSON.stringify(key)} value: ${JSON.stringify(value)} `)
      if (key !== undefined && key !== null &&
          value !== undefined && value !== null &&
          self.itemsObject !== undefined &&
          self.itemsObject !== null &&
          self.itemsObject[value] !== undefined) {
        switch (key) {
          case 'started':
          case 'running':
            self.itemsObject[value].accountStatusDescription = 'running'
            self.itemsObject[value].accountStatus = 0
            break
          case 'completed':
            self.itemsObject[value].accountStatusDescription = key
            self.itemsObject[value].accountStatus = 1
            break
          case 'failed':
          case 'error':
            self.itemsObject[value].accountStatusDescription = 'failed'
            self.itemsObject[value].accountStatus = 2
            break
          case 'terminated':
            self.itemsObject[value].accountStatusDescription = key
            self.itemsObject[value].accountStatus = 3
            break
        }
      }
    },
    onChatMessage (m) {
      let self = this
      // console.log(`m: ${JSON.stringify(m)}`)
      if (m !== undefined) {
        switch (m) {
          case 'NEW_ITEM_ADDED':
            self.LoadData()
            break
          case 'CLIENT_CONNECTED':
          case 'CLIENT_DISCONNECTED':
          case 'WELCOME':
            break
          default:
            try {
              var p = JSON.parse(m)
              if (p.Type !== undefined && self.itemsObject !== undefined && self.itemsObject[p.Account] !== undefined) {
                if (self.itemsObject[p.Account].pid !== p.pid) {
                  self.itemsObject[p.Account].pid = p.pid
                }
                self.itemsObject[p.Account].accountStatus = parseInt(p.Type)
                self.itemsObject[p.Account].accountStatusDescription = p.TypeName

                if (self.itemsObject[p.Account].log.filter(u => u.Key === p.Key).length === 0) {
                  self.itemsObject[p.Account].log.push(p)
                }

                switch (p.Type) {
                  // running
                  case '0':
                    break
                    // completed
                  case '1':
                    // console.log(`accountLastRun: ${JSON.stringify(self.itemsObject[p.Account].accountLastRun)} new Timestamp:  ${JSON.stringify(p.Timestamp)}`)
                    self.itemsObject[p.Account].accountLastRun = p.Timestamp
                    break
                    // failed
                  case '2':
                    break
                    // terminated
                  case '3':
                    break
                }
              }
            } catch (e) {

            }
            break
        }
      }
    },
    ConnectSocket () {
      let self = this
      // eslint-disable-next-line no-undef
      self.chat = $.connection.chatHub
      // Create a function that the hub can call back to display messages.

      self.chat.client.sendChatMessage = function (name, message) {
        self.onChatMessage(message)
      }

      self.chat.client.sendSpecialMessage = function (key, value) {
        self.onSpecialMessage(key, value)
      }
      // eslint-disable-next-line no-undef
      $.connection.hub.start()
        .done(function () {

        }).fail(function (err) {
          self.toggleloader(false)
          let msg = 'Hubs starting: failed '
          self.showError(msg)
          console.log(`${msg} ${JSON.stringify(err)}`)
        })
    },
    LoadData () {
      let self = this
      if (self.gettingData === false) {
        self.gettingData = true

        self.Items.splice(0)
        self.itemsObject = undefined
        self.itemsObject = {}

        self.toggleloader(true)

        axios.get('/api/Inventory/GetStatuses')
          .then(response => {
            if (response.data === undefined || response.data === null) {
              self.itemsObject = {}
            } else {
              self.totalCount = response.data.length

              try {
                var fromServer = response.data.map(function (item) {
                  item['overrideFileIfExists'] = false

                  if (typeof item.log === 'string' || item.log instanceof String) {
                    item.log = []
                  } else if (item.log === undefined) {
                    item.log = []
                  } else {
                    item.log = item.log.map(function (subitem) {
                      try {
                        return JSON.parse(subitem)
                      } catch (r) {
                        console.log(r)
                        console.log(JSON.stringify(subitem))
                      }
                    })
                    item.log = item.log.filter(function (element) {
                      return element !== undefined
                    })
                  }
                  return item
                })

                for (let i = 0; i < fromServer.length; i++) {
                  let currentItem = fromServer[i]

                  if (self.itemsObject[currentItem.account] === undefined) {
                    self.itemsObject[currentItem.account] = currentItem
                  } else {
                    Object.assign(self.itemsObject[currentItem.account], currentItem)
                  }
                  self.Items.push(currentItem)
                }
              } catch (e) {
                console.log(e)
              }
            }
          })
          .catch(error => {
            self.handleError(error)
          }).then(() => {
            self.toggleloader(false)
            self.gettingData = false
          })
      }
    },
    RefreshData () {
      this.LoadData()
    },
    /**
     * @return {boolean}
     */
    IsDanger (item) {
      // 0 running
      // 1 completed
      // 2 failed
      // 3 terminated
      let status = parseInt(item.accountStatus)
      if (status === 2 || status === 3) {
        return true
      }
      return false
    },
    /**
     * @return {boolean}
     */
    CanRunImport (item) {
      // accountStatus / accountStatusDescription:
      // -1 never run before
      // 0 running
      // 1 completed
      // 2 failed
      // 3 terminated
      let currentStatus = parseInt(item.accountStatus)
      if (currentStatus === 1 || currentStatus === 2 || currentStatus === 3 || currentStatus === -1) {
        return true
      }
      return false
    },
    RunImport (account, accountName, overrideFileIfExists) {
      let self = this

      let obj = {
        AccountId: account,
        AccountName: accountName,
        OverrideFileIfExists: overrideFileIfExists
      }

      axios.post('/api/Inventory/Process', obj)
        .then(response => {
          if (response.data !== undefined && response.data !== null) {
            for (let i = 0; i < self.Items.length; i++) {
              if (self.Items[i].account === account) {
                self.Items[i].pid = response.data + ''
              }
            }
          }

          self.toggleloader(false)
          self.showNotification('Import started')
        })
        .catch(error => {
          self.handleError(error)
        }).then(() => {
          self.toggleloader(false)
        })
    },
    CanBeTerminated (item) {
      // accountStatus / accountStatusDescription:
      // 0 running
      // 1 completed
      // 2 failed
      // 3 terminated
      if (parseInt(item.accountStatus) === 0) {
        return true
      }
      return false
    },
    RunTerminate (pid, account) {
      let self = this

      let message = 'Are you sure you would like to terminate it?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.toggleloader(true)

          let obj = {
            pid: pid,
            account: account
          }

          axios.post('/api/Inventory/TerminatePid', obj)
            .then(response => {
              self.showWarning('Task was terminated')
            })
            .catch(error => {
              self.handleError(error)
            }).then(() => {
              self.toggleloader(false)
            })
        })
        .catch(function () {

        })
    },

    ProcessAll () {
      let self = this

      let message = 'Are you sure you would like to run it?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.toggleloader(true)

          axios.post('/api/Inventory/ProcessAll', {})
            .then(response => {
              if (response.data !== undefined && response.data !== null) {
                let pidArray = response.data
                let pidArrayLength = pidArray.length
                let itemsLength = self.Items.length

                for (let i = 0; i < itemsLength; i++) {
                  let currentAccount = self.Items[i].account
                  let found = false
                  for (let j = 0; j < pidArrayLength; j++) {
                    if (currentAccount === pidArray[j].Key) {
                      found = true
                      // console.log(`pid changed: ${self.Items[i].pid} -> ${pidArray[j].Value}`)
                      self.Items[i].pid = pidArray[j].Value
                    }
                  }
                  if (found === false) {
                    self.Items[i].pid = '00000000-0000-0000-0000-000000000000'
                  }
                }
              }
              self.showNotification('Import all started')
            })
            .catch(error => {
              self.handleError(error)
            }).then(() => {
              self.toggleloader(false)
            })
        })
        .catch(function () {

        })
    },
    TerminateRunning () {
      let self = this

      let message = 'Are you sure you would like to Terminate Running?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.toggleloader(true)

          axios.post('/api/Inventory/TerminateAll', {})
            .then(response => {
              self.showNotification('Terminate all started')
            })
            .catch(error => {
              self.handleError(error)
            }).then(() => {
              self.toggleloader(false)
            })
        })
        .catch(function () {

        })
    },
    /**
     * @return {number}
     */
    GetRowCount () {
      let self = this
      return self.FilteredRecords.length
    },
    /**
     * @return {boolean}
     */
    CanGetLog (item) {
      if (item.log === undefined || item.log === null || item.log.length === 0) {
        return false
      }
      return true
    },
    ClearSearch () {
      let self = this
      self.tbxFilter = undefined
    },
    EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.ClearSearch()
      }
    },
    GetLogEntryClass (logEntry) {
      let lowermsg = logEntry.Message.toLowerCase()
      return {
        'table-success': lowermsg === 'stop' || lowermsg === 'start',
        'table-danger': lowermsg.includes('error') || lowermsg.includes('exception') || lowermsg.includes('fail') || lowermsg.includes('terminate')
      }
    }
  },
  filters: {
    formatDate: function (date) {
      let m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatDateToNow: function (date) {
      let m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true) + ' ago'
      }
      return ''
    }
  },
  watch: {
    tbxFilter: function (val) {
      if (val === null || val === 'null' || val === 'undefined') {
        val = undefined
      }
      localStorage.setItem('InventoryDownloadtbxFilter', val)
    }
  },
  computed: {
    FilteredRecords: function () {
      let self = this
      if (self.Items === undefined || self.Items === null) {
        return []
      } else {
        if (self.tbxFilter !== undefined && self.tbxFilter !== null && self.tbxFilter.length > 0) {
          return self.Items.filter(u => (u.account + '').toLowerCase().includes(self.tbxFilter.toLowerCase()) ||
            (u.accountName + '').toLowerCase().includes(self.tbxFilter.toLowerCase()) ||
            (u.accountStatusDescription + '').toLowerCase().includes(self.tbxFilter.toLowerCase())
          )
        } else {
          return self.Items
        }
      }
    },
    RecordsStatistics: function () {
      let self = this
      let data = {
        running: 0,
        completed: 0,
        failed: 0,
        terminated: 0
      }
      if (self.Items === undefined || self.Items === null) {
        return data
      } else {
        let count = self.Items.length

        for (let j = 0; j < count; j++) {
          // 0 running
          // 1 completed
          // 2 failed
          // 3 terminated
          let status = parseInt(self.Items[j].accountStatus)
          switch (status) {
            case 0:
              data.running++
              break
            case 1:
              data.completed++
              break
            case 2:
              data.failed++
              break
            case 3:
              data.terminated++
              break
          }
        }
      }
      return data
    }
  },
  beforeDestroy () {
    try {
      // eslint-disable-next-line no-undef
      $.connection.hub.stop()
    } catch (e) {
      console.log(`Error while stopping hub: ${JSON.stringify(e)}`)
    }
  },
  destroyed () {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/InventoryDownload.vue